import React from 'react'
import { uniqueId } from 'lodash'
import Checkbox from '@ublique/components/Checkbox'
import 'pages/Administration/components/index.scss'

const TablesPermission = ({
  data,
  permissionType: { id, disabled = false },
  isOutput = false
}) => {
  const { disabled: disableList } = data

  const permission = isOutput ? data : data?.permission

  const checkboxId = uniqueId(`${id}-`)
  // TODO permissions and permission are the exact same object
  // Understand how to handle it
  const permissions = {
    read: permission?.read,
    create: permission?.create,
    update: permission?.update,
    delete: permission?.delete,
    import_: permission?.import_,
    export: permission?.export
  }

  const handleOnClick = (e) => {
    e.stopPropagation()
  }

  return (
    <div className='centre-align'>
      <div className='permissions-checklist' key={id}>
        <Checkbox
          id={checkboxId}
          checked={permissions[id]}
          disabled={disabled || disableList?.[id]}
          onClick={handleOnClick}
        />
      </div>
    </div>
  )
}

export default TablesPermission
